export default "/assets/drag_preview-32dbfa3ed4bdbdbce1f72475260ddad509b8c9657c7518df239dbab7541f8e04.png";